// extracted by mini-css-extract-plugin
export default {"main_div":"PatientModal_main_div__TDhoP","error_msg":"PatientModal_error_msg__zyPPN"};